export enum SmsTypeEnum {
  INTRODUCE = 'introduce',
  SITE = 'site',
  OXIN_POLAD = 'oxin_polad',
  NEGIN_POLAD = 'negen-polad',
}

export type SmsOption = {
  label: string
  value: SmsTypeEnum
}

export type Props = {
  defaultPhonNumber?: string
}
